import { collectionEngineV1 } from '../apis.js';
const reqCases = collectionEngineV1('/cases');
export const getById = (id, casualConsistency) => reqCases('GET', `/${id}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const create = (c) => reqCases('POST', '/', { body: c });
export const patch = (id, data) => reqCases('PATCH', `/${id}`, { body: data });
export const merge = (fromCaseId, data) => reqCases('PATCH', `/${fromCaseId}/merge`, { body: data });
export const undoMerge = (caseId, updateId) => reqCases('PATCH', `/${caseId}/merge/undo/${updateId}`, {});
export const deleteCase = (id) => reqCases('DELETE', `/${id}`);
export const recognize = (searchStrings) => reqCases('POST', `/recognizer`, {
    body: { strings: searchStrings },
});
export const getAll = async (caseFilter, offset, limit, filters, creditorId) => {
    let query = '?';
    if (offset != undefined) {
        query = query + `offset=${offset}`;
    }
    if (limit != undefined) {
        query = query + `&limit=${limit}`;
    }
    if (creditorId != undefined) {
        query = query + `&creditorId=${creditorId}`;
    }
    return reqCases('POST', '/list' + query, {
        body: { caseFilter, filters },
    });
};
export const index = (id) => reqCases('POST', `/${id}/index`);
export const getInsightsTotals = () => reqCases('GET', `/insights/totals`);
//# sourceMappingURL=cases.js.map